'use client';

import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import React from 'react';
import { getCategoriesBySearchParamsApplied } from 'sb-shell/app/(normalRender)/new-pages/(search)/[mediaType]/search/_Filters/FilterUtils';
import {
    getContentClassByContentType,
    getContentTypeFromMediaType,
    getSearchUrl,
    SearchFilterContentTypes,
    SearchFilterMediaTypes,
    SearchOrigins,
} from 'search-gateway-client';

import { Text } from '@videoblocks/design-system';

interface Props {
    mediaType: SearchFilterMediaTypes;
}

const CategoryLinks = ({ mediaType }: Props) => {
    const searchParams = useSearchParams();
    const contentType: SearchFilterContentTypes = getContentTypeFromMediaType(mediaType);
    const categories = getCategoriesBySearchParamsApplied(
        getContentClassByContentType(contentType),
        new URLSearchParams(searchParams.toString()),
    );

    if (
        !categories.length ||
        (
            [
                SearchFilterContentTypes.All_audio_content_type,
                SearchFilterContentTypes.All_videos_content_type,
                SearchFilterContentTypes.All_images_content_type,
            ] as SearchFilterContentTypes[]
        ).includes(contentType)
    ) {
        return null;
    }

    return (
        <div className="grid">
            <Text fontSize="sm" fontWeight="regular" className="text-gray-600 mt-5.5 mb-2.75">
                Categories in {contentType}
            </Text>
            <div className="overflow-hidden flex overflow-x-scroll scrollbar-hidden whitespace-nowrap space-x-2 space-y-1">
                {categories.map((category) => (
                    <Text fontWeight="regular" asChild key={`category-link-${category.label}`}>
                        <Link
                            href={getSearchUrl({
                                contentType: contentType,
                                categoryUrlIds: [category.urlId],
                            })}
                            prefetch={false}
                            className="text-gray-900 no-underline bg-gray-100 border border-gray-500 rounded-full py-2 px-6"
                        >
                            {category.label}
                        </Link>
                    </Text>
                ))}
            </div>
        </div>
    );
};

export default CategoryLinks;
